var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1060.87 37.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;}.cls-2{fill:url(#linear-gradient);}.cls-3{opacity:0.05;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.58,
    y1: 18.62,
    x2: 1060.87,
    y2: 18.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a535f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06304b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 10.5,
    x2: 1055.3,
    y2: 10.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 27.48,
    x2: 1055.3,
    y2: 27.48,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeline"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.58,18.62l66-.53,66-.45,132-.56c44-.24,88-.2,132-.29l132-.18,132,.18,66,.09,33,.05,33,.14,132,.56,66,.45,66,.53-66,.53-66,.45-132,.56-33,.14-33,.05-66,.09-132,.18-132-.18c-44-.09-88,0-132-.29l-132-.56-66-.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,21c21.9-2.16,43.83-3.94,65.78-5.54,11-.86,22-1.56,32.93-2.3s22-1.5,32.94-2.11l33-1.85c11-.62,22-1.06,33-1.61l33-1.54,33-1.25,33-1.24,33-.86,33-.85c5.5-.16,11-.24,16.5-.32l16.5-.26,33-.52c11-.17,22-.38,33-.39l66-.35,8.25,0,8.25.06L560.59.2l33,.28,33,.28,33,.62,66,1.31c22,.62,44,1.41,66,2.17L824.6,6l8.25.29,8.24.39,16.49.78,65.94,3.11,16.48.82,16.47,1,32.94,2.07,65.88,4.23-65.93-3.17-33-1.62-16.48-.79-16.49-.6-66-2.55L841,9.34,832.75,9,824.5,8.8l-33-.86-66-1.78L659.56,5l-33-.53-33-.19-33-.19L544.08,4l-8.25,0-8.25,0c-88-.18-176,1.27-263.93,3.84l-33,1-33,1.27c-11,.45-22,.8-33,1.33l-33,1.56C87.81,15.09,43.88,17.62,0,21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,17c43.88,3.38,87.81,5.91,131.76,8l33,1.56c11,.53,22,.88,33,1.33l33,1.27,33,1c88,2.57,175.94,4,263.93,3.84l8.25,0,8.25,0,16.5-.09,33-.19,33-.19,33-.53,66-1.13,66-1.78,33-.86,8.25-.22,8.24-.32L857.48,28l66-2.55,16.49-.6,16.48-.79,33-1.62,65.93-3.17-65.88,4.23-32.94,2.07-16.47,1-16.48.82-65.94,3.11-16.49.78-8.24.39L824.6,32l-33,1.14c-22,.76-44,1.55-66,2.17l-66,1.31-33,.62-33,.28-33,.28-16.51.14-8.25.06-8.25,0-66-.35c-11,0-22-.22-33-.39l-33-.52L379,36.44c-5.5-.08-11-.16-16.5-.32l-33-.85-33-.86-33-1.24-33-1.25-33-1.54c-11-.54-22-1-33-1.61l-33-1.85c-11-.6-22-1.38-32.94-2.11s-22-1.44-32.93-2.3C43.83,20.92,21.9,19.14,0,17Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.0d4ac2ef0c274b5115d6638220d388cf.svg";
export { ForwardRef as ReactComponent };